module.exports = __webpack_public_path__ + "img/D.4f3e4b69.svg";